import { get } from '../tools/http';

const perPage = 4;

export default {
    state: {
        pagesCount: 1,
        pages: {},
        currentItem: null,
    },
    mutations: {
        addPage: (state, value) => {
            const page = {
                list: value.list,
                time: Date.now(),
            };

            state.pagesCount = Math.ceil(value.count / perPage);
            state.pages = { ...state.pages, [value.page]: page };
        },

        fillPages: (state, value) => state.pages = value,

        setPagesCount: (state, value) => state.pagesCount = value,

        writeCurrentItem: (state, value) => state.currentItem = value,
    },
    actions: {
        loadStories: async (ctx, page) => {
            const offset = (page - 1) * perPage;
            const params = { limit: perPage, offset };

            const res = await get('cms', 'entity/select/successStory', params);

            const value = {
                list: res.list,
                count: res.count,
                page,
            };

            ctx.commit('addPage', value);
            return res;
        },

        loadMillionStories: async ctx => {
            const params = { limit: 1e6, offset: 0 };

            const res = await get('cms', 'entity/select/successStory', params);

            const time = Date.now();
            const pagesCount = Math.ceil(res.count / perPage);

            const pages = {};

            for (let i = 0; i < pagesCount; i++) {
                const start = i * perPage;

                pages[i + 1] = {
                    list: res.list.slice(start, start + perPage),
                    time,
                };
            }

            ctx.commit('fillPages', pages);
            ctx.commit('setPagesCount', pagesCount);
        },

        loadStory: async (ctx, id) => {
            const res = await get('cms', 'entity/select/successStory', { id });
            ctx.commit('writeCurrentItem', res.list[0]);
            return res;
        },
    },
    getters: {
        pagesCount: state => state.pagesCount,
        pages: state => state.pages,
        currentItem: state => state.currentItem,

        examples: state => {
            const lists = Object.values(state.pages).map(p => p.list);

            return lists.reduce((acc, cur) => [...acc, ...cur], []);
        },
    },
};
